import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../css/preload.min.css";
import "../css/icomoon.css";
import "../css/about.min.css";
import "../css/index.min.css";
import default_banner from "../img/golf-image.jpg";
import "../scss/custom.scss";
import logo from "../img/loho.png";
import axios from "axios";
import CountdownTimer from "../components/CountdownBanner";
import { getPricingInfo } from "../utils/pricingUtils";

const Individual = () => {
  const [data, setData] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [showError, setShowError] = useState(false);
  const [disabled, setDisabled] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [individuals, setIndividuals] = useState([]);
  const pricing = getPricingInfo();

  const handleChange = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };

  useEffect(() => {
    if (data.full_name && data.email && data.phone && data.asq) {
      setDisabled(false);
    } else {
      setDisabled(true);
    }
  }, [data]);

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    try {
      const response = await axios.get(
        "https://ihm-golf-tournament-spreadsheet.vercel.app/individuals",
      );
      if (response.data) {
        setIndividuals(response.data);
      } else {
        console.log("No data found. Contact admin.");
      }
    } catch (error) {
      console.error(error);
    }
  };

  const submitForm = async () => {
    setSubmitting(true);
    try {
      if (data.asq === "4") {
        let result = await axios.post(
          `https://ihm-golf-tournament-spreadsheet.vercel.app/individuals`,
          data,
        );
        if (result.status === 200) {
          setShowSuccess(true);
        } else {
          setShowError(
            "There was an error submitting your registration. Please try again.",
          );
        }
      } else {
        setShowError(
          "You've incorrectly answered the anti-bot question. Please refresh and try again.",
        );
      }
    } catch (error) {
      setShowError(
        "There was an error submitting your registration. Please try again later.",
      );
      console.error(error);
    } finally {
      setSubmitting(false);
    }
  };

  // Sticky Menu Area
  useEffect(() => {
    window.addEventListener("scroll", isSticky);
    return () => {
      window.removeEventListener("scroll", isSticky);
    };
  });

  const mappedArray = individuals.map((innerArray) => {
    return (
      <tr>
        {innerArray.map((value, index) => {
          if (index !== 1) {
            return <td key={index}>{value}</td>;
          }
          return null;
        })}
      </tr>
    );
  });

  const isSticky = (e) => {
    const header = document.querySelector(".headroom");
    const scrollTop = window.scrollY;
    if (header) {
      scrollTop >= 250
        ? header.classList.add("is-sticky")
        : header.classList.remove("is-sticky");
    }
  };

  return (
    <>
      <main>
        <div className="">
          <CountdownTimer />
        </div>
        {/* hero section start */}
        <div className="hero-container">
          <div className="overlay">
            <picture>
              <source data-srcset={default_banner} srcSet={default_banner} />
              <img
                className="lazy"
                data-src={default_banner}
                src={default_banner}
                alt="media"
              />
              <div className="overlay"></div>
            </picture>
          </div>
          <section className="hero section">
            <div
              data-aos="zoom-in"
              className="container container--hero d-lg-flex align-items-center justify-content-center"
            >
              <div className="">
                <img
                  className="banner-logo"
                  src={logo}
                  alt="IHM GOLF TOURNAMENT"
                ></img>
                <h1>
                  <span className="subtitle">Individual Registration</span>
                  <br /> Golf Tournament
                </h1>
                <p>
                  <i className="icon-location"></i> THE PONDS GOLF COURSE
                </p>
              </div>
            </div>
          </section>
        </div>

        {/* Registration section */}
        <div class="main-content">
          <nav className="breadcrumbs">
            <div className="container">
              <a href="/">Home</a>
              <span className="separator">/</span>
              <span className="current">Individual Registration</span>
            </div>
          </nav>
          <section className="section dark primary-bg main">
            <div className="block" />
            <div className="container">
              <div className="align-items-center mb-1">
                <h3 className="max-width" data-aos="fade-right">
                  Individual Registration
                </h3>
                <p>
                  Register as an individual player here. We'll match you with
                  other players.
                  <br />
                  <strong>All fields required.</strong>
                </p>
                <div className="contacts_secondary-form" data-aos="fade-left">
                  <div className="contacts" data-aos="fade-left">
                    <div className="contacts_header">
                      <p className="input-grouping">
                        <span>Full Name</span>
                        <div className="field-wrapper mt-2">
                          <input
                            onChange={handleChange}
                            value={data.full_name}
                            className="field required"
                            type="text"
                            placeholder="Enter Full Name"
                            name="full_name"
                          />
                        </div>
                      </p>
                      <p className="input-grouping">
                        <span>Email</span>
                        <div className="field-wrapper mt-2">
                          <input
                            className="field required"
                            type="email"
                            placeholder="Enter Email Address"
                            onChange={handleChange}
                            name="email"
                            value={data.email}
                          />
                        </div>
                      </p>
                      <p className="input-grouping">
                        <span>Phone</span>
                        <div className="field-wrapper mt-2">
                          <input
                            className="field required"
                            type="tel"
                            placeholder="Enter Phone Number"
                            onChange={handleChange}
                            name="phone"
                            value={data.phone}
                          />
                        </div>
                      </p>
                      <p className="input-grouping">
                        <p className="mt-5">
                          <strong>Anti-Bot Question</strong>
                        </p>
                        <span>What is 2 + 2?</span>
                        <div className="field-wrapper mt-2">
                          <input
                            className="field required"
                            type="text"
                            onChange={handleChange}
                            name="asq"
                            value={data.asq}
                          />
                        </div>
                      </p>
                      {disabled && (
                        <p className="sm-p">
                          Please fill in all fields to submit registration.
                        </p>
                      )}
                      <button
                        disabled={disabled || submitting}
                        onClick={submitForm}
                        className="btn theme-element theme-element--accent mt-4"
                      >
                        {submitting ? (
                          <>
                            <i className="fas fa-spinner fa-spin" />{" "}
                            Submitting...
                          </>
                        ) : (
                          <>
                            <i className="fas fa-share" /> Submit Registration
                          </>
                        )}
                      </button>
                      {showSuccess && (
                        <p className="mt-3" data-aos="fade-up">
                          Your registration has been submitted. Please pay fee
                          below and you'll be all set! Once registration has
                          been confirmed, you'll be added to a team.
                        </p>
                      )}
                      {showError && (
                        <p className="mt-3" data-aos="fade-up">
                          {showError}
                        </p>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* Payment section */}
          <section className="section location pb-5" data-aos="fade-left">
            <div className="container">
              <div className="row">
                <div className="col-lg-6">
                  <h3 className="mb-4">Payment</h3>
                  <p>
                    <strong>Tournament Fee:</strong>{" "}
                    {pricing.isEarlyBird ? (
                      <>
                        <span
                          style={{
                            textDecoration: "line-through",
                            marginRight: "8px",
                            opacity: "0.7",
                          }}
                        >
                          ${pricing.regularPrice}
                        </span>
                        ${pricing.earlyBirdPrice}
                      </>
                    ) : (
                      `$${pricing.currentPrice}`
                    )}
                    /Golfer
                  </p>
                  {pricing.isEarlyBird && (
                    <p className="mt-2 mb-4">
                      <em>
                        Early Bird Special - Register before April 30th and save
                        $15!
                      </em>
                    </p>
                  )}
                  <p className="mt-3">
                    <span>
                      <strong>Pay with Paypal:</strong>
                    </span>
                    <div className="mt-3">
                      <a
                        href="https://www.paypal.com/ncp/payment/FNNRPU8Z9SRU4"
                        className="theme-element btn"
                      >
                        PAY NOW
                      </a>
                    </div>
                  </p>
                  <p>
                    <strong>Or send payments (cash or check) to:</strong>
                    <br />
                    <br />
                    Immaculate Heart of Mary Academy
                    <br />
                    777 221st. Avenue NW
                    <br />
                    Oak Grove, MN 55011
                  </p>
                  <p>
                    Please make checks payable to: <br />
                    "IHM Academy"
                  </p>
                </div>
              </div>
            </div>
          </section>

          {/* Registered individuals section 
        {individuals.length > 0 && (
          <section className="section neutral-bg">
            <div className="container">
              <h3 className="mb-4">Registered Individuals</h3>
              <p>Players listed have been confirmed.</p>
              <div className="table-wrapper">
                <table>
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Phone</th>
                    </tr>
                  </thead>
                  <tbody>{mappedArray}</tbody>
                </table>
              </div>
              <p className="sm-p mt-3 mobile">Swipe right to view more.</p>
            </div>
          </section>
        )}
          */}
        </div>
      </main>

      <footer className="footer accent">
        <div className="container">
          <div className="footer_copyright">
            <div className="container">
              <p className="footer_copyright-text">
                <span className="linebreak">
                  Made by Up North Creative
                  <br />
                </span>
                <span className="linebreak">All rights reserved © 2026</span>
              </p>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Individual;
